"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SensorPublished = void 0;
const react_1 = __importDefault(require("react"));
const ReactiveComponent_1 = __importDefault(require("@usereactify/search-internals/lib/components/basic/ReactiveComponent"));
const hooks_1 = require("../../hooks");
const props_1 = require("../../utility/props");
const SensorPublished = () => {
    const reactifySearchContext = (0, hooks_1.useReactifySearchContext)();
    const reactiveProps = (0, props_1.getPropsSensorPublished)({
        config: reactifySearchContext.config,
        provider: reactifySearchContext.options,
    });
    return (react_1.default.createElement(ReactiveComponent_1.default, Object.assign({}, reactiveProps)));
};
exports.SensorPublished = SensorPublished;
//# sourceMappingURL=SensorPublished.js.map